<template>

  <InputBlock
    :label="label"
    :name="name"
    :help="help"
    :isRequired="isRequired"
    :isInvalid="!isValid"
    :classes="[
      'input-block--password',
      `input-block--name-${name}`,
      ...classes,
    ]">

    <input
      :id="name"
      v-model="value"
      ref="input"
      type="password"
      :placeholder="placeholder"
      :disabled="isDisabled"
      :required="isRequired"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="$emit('enter', value)">

      <template #alerts>
        <div v-if="!isValid">{{$t('error.invalid_password')}}</div>
        <slot></slot>
      </template>

    <template #link>
      <slot name="link"></slot>
    </template>

  </InputBlock>
</template>

<script>
import Check from '@/services/check/Check';
import InputProps from '../InputProps';
import InputMixin from '../InputMixin';
import InputBlock from '../InputBlock.vue';

export default {
  name: 'InputPassword',
  mixins: [
    InputMixin,
  ],
  components: {
    InputBlock,
  },
  props: InputProps.props,
  computed: {
    isValid() {
      return this.isRequired && this.value
        ? Check.isValidPassword(this.value)
        : true;
    },
  },
};
</script>
